import React, { useState, useEffect, useRef } from "react";
import Header from "../../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import { GET_ACCOUNT_INFO, GET_USER_INFO } from "../../utils/constants";
import { IAccount, ISavedBook, IUser } from "../../utils/types";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";
import user from "../../assets/user.svg";
import linkedIn from "../../assets/linkedIn.svg";
import twitter from "../../assets/twitter.svg";
import link from "../../assets/link-45deg.svg";
import edit from "../../assets/edit.svg";
import EditAccountForm from "../../components/AccountEditForm";
import back from '../../assets/back.svg';

const EditAccount = () => {
  const navigate = useNavigate();
  const [savedBooks, setSavedBooks] = useState<ISavedBook[]>([]);
  const [message, setMessage] = useState("");
  const [userDetails, setUserDetails] = useState<IUser | null>(null);
  const [accountDetails, setAccountDetails] = useState<IAccount | null>(null);

  const socialImg: any[] = [linkedIn, twitter, link];

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    document.title = "Edit Account - Nclude Portal";
    fetchUserDetails();
    fetchAccountInfo();
  }, []);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  const fetchUserDetails = async () => {
    try {
      const resp = await makeAuthenticatedGet(GET_USER_INFO);
      console.log(resp);
      // resp.user.social = ["ab", "ac", "ad"];
      // resp.user.resume = ["https://ccpd.nic.in/list-of-states-uts-commissioners/#"];
      if (resp.success) {
        setUserDetails(resp.user);
        // console.log(userDetails);
      }
    } catch (error) {}
  };
  const fetchAccountInfo = async () => {
    try {
      const resp = await makeAuthenticatedGet(GET_ACCOUNT_INFO);
      console.log(resp);
      if (resp.success) {
        setAccountDetails(resp.data);
        // console.log(userDetails);
      }
    } catch (error) {}
  };

  const handleViewBtn = async (bookUrl: string) => {
    try {
      window.open(bookUrl, "_blank");
    } catch (error) {}
  };

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  function handleLinkEmail(): void {
    navigate("/link");
  }

  function userEdit(): void {
    throw new Error("Function not implemented.");
  }

  function accountEdit(): void {
    throw new Error("Function not implemented.");
  }



  return (
    <div className="">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="Profile" />
        <div
          className="doc-container"
          role="main"
          tabIndex={-1}
          style={{ position: "relative" }}
        >
            <div
                style={{
                  color: "#5030E5",
                  cursor: "pointer",
                  fontSize: isMobile?"2rem":"1rem",
                  gap: "0.2rem",
                  marginBottom:isMobile?"2rem":"1rem"
                }}
                className="d-flex single-article back-button"
                role="button"
                onClick={()=> navigate(-1)}
              >
                <img src={back} alt="" aria-hidden="true" style={{ width: isMobile?"3rem":"2rem" }}/>
                Back
              </div>
          <h1 className="display-title" ref={mainRef} tabIndex={-1}>{"Account Information"}</h1>
          {/* <HelperAccordion val='doc' /> */}
          <div className="component-container form-container upload-form-container">
            <EditAccountForm accountDetails={accountDetails}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAccount;
